
import Vue from 'vue';
import alert from './components/alert.vue'

let pond = {},market = {}

const create_call = mine=>option=>{
    if (pond[mine.name]) {
        pond[mine.name].$destroy()
        pond[mine.name].$el.parentNode.removeChild(pond[mine.name].$el)
    }
    const Vm = Vue.extend(mine)
    let instance = new Vm({
        el: document.createElement('div')
    })
    instance = Object.assign(instance,option)
    pond[mine.name] = instance
    document.body.appendChild(instance.$el)
}

const requireComponent = require.context(
    // 其组件目录的相对路径
    './components',
    // 是否查询其子目录
    true,
    // 匹配基础组件文件名的正则表达式
    /\w+\.vue$/
)

requireComponent.keys().forEach(fileName => {
    // 获取组件配置
    const componentConfig = requireComponent(fileName)

    let componentName = null

    // 检测该文件与父文件夹是否同名
    let arr = fileName.split('/').slice(1).map(item => item.replace(/(\w).vue$/, '$1'))
    if (arr.length > 1 && arr[arr.length - 1] == arr[arr.length - 2]) {
        // 组合文件名
        componentName = arr.slice(0, -1).reduce((accu, current) => `${accu}${current}`)
    } else {
        // 获取组件的 PascalCase 命名
        componentName = fileName.replace(/^\.\/(.*)\.\w+$/, '$1')
    }
    
    market[componentName] = create_call(componentConfig.default || componentConfig)
})
export default market